var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.actionlist, function (action) {
        return [
          _c(
            "v-dialog-action",
            _vm._b(
              {
                key: action.key,
                staticClass: "ml-2",
                class: { loading: _vm.loadingAction === action.key },
                attrs: {
                  "action-key": "" + action.key,
                  loading: !_vm.passive && _vm.isActionInLoading(action),
                  disabled:
                    _vm.isActionDisabled(action) ||
                    (!_vm.passive && Boolean(_vm.loadingAction)),
                },
                on: {
                  click: function ($event) {
                    return _vm.onActionClick(action)
                  },
                },
              },
              "v-dialog-action",
              _vm.getActionProps(action),
              false
            )
          ),
        ]
      }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }